// extracted by mini-css-extract-plugin
export default {"root":"styles_root__9eDQ0","img":"styles_img__XEIHp","grab":"styles_grab__SC+82"};